module.exports = __webpack_public_path__ + "img/0Q3A7250_P_L_BlackMatted_MockedUp.c3468cee.jpg";